"use client";

import "./globals.css";
import { useErrorRecovery } from "@/hooks/useErrorRecovery";

// Erro no layout raiz (fora do alcance de app/error.tsx). Substitui o
// documento inteiro, por isso define <html>/<body>. Mesma recuperação
// automática da loja (lib/runtime/errorRecovery.ts): erro de carregamento de
// código/rede -> um recarregamento completo; outros -> uma nova tentativa.
export default function GlobalError({
  error,
  reset,
  retry,
}: {
  error: Error & { digest?: string };
  reset: () => void;
  retry?: () => void;
}) {
  const tryAgain = retry ?? reset;
  const recovering = useErrorRecovery(error, tryAgain, "[storefront-global-error]");

  return (
    <html lang="pt-BR">
      <body className="bg-slate-50 text-slate-900">
        <title>Persi Materiais</title>
        <main className="flex min-h-screen items-center justify-center px-4 py-12">
          {recovering ? (
            <p role="status" aria-live="polite" className="text-slate-600">Atualizando a página…</p>
          ) : (
            <section className="w-full max-w-xl rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm sm:p-8">
              <h1 className="text-2xl font-bold text-[#071f5c]">Não foi possível carregar esta página</h1>
              <p className="mt-3 text-slate-600">Houve uma falha temporária ao consultar a loja. Tente novamente em instantes.</p>
              <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
                <button
                  type="button"
                  onClick={tryAgain}
                  className="inline-flex min-h-11 items-center justify-center rounded-xl bg-[#ff6a00] px-5 font-semibold text-white hover:bg-[#e55f00] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#071f5c]"
                >
                  Tentar novamente
                </button>
                <button
                  type="button"
                  onClick={() => window.location.reload()}
                  className="inline-flex min-h-11 items-center justify-center rounded-xl border border-[#0c2d72] px-5 font-semibold text-[#0c2d72] hover:bg-blue-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#071f5c]"
                >
                  Recarregar a página
                </button>
              </div>
              {error.digest ? <p className="mt-5 text-xs text-slate-500">Código: {error.digest}</p> : null}
            </section>
          )}
        </main>
      </body>
    </html>
  );
}
